import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.63659 12.728H6.36386V1.27344H7.63659V12.728ZM2.54568 2.54616H5.09113V3.81889H2.54568V10.1825H5.09113V11.4553H2.54568C1.84249 11.4553 1.27295 10.8855 1.27295 10.1825V3.81889C1.27295 3.11596 1.84249 2.54616 2.54568 2.54616ZM8.90931 11.4553H10.182V10.1825H8.90931V11.4553ZM11.4548 10.1825V11.4553C12.1579 11.4553 12.7275 10.8855 12.7275 10.1825H11.4548ZM11.4548 8.9098H12.7275V7.63707H11.4548V8.9098ZM12.7275 6.36435H11.4548V5.09162H12.7275V6.36435ZM11.4548 2.54616C12.1579 2.54616 12.7275 3.11596 12.7275 3.81889H11.4548V2.54616ZM10.182 3.81889H8.90931V2.54616H10.182V3.81889Z",
  fill: "#FEFEFE"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("mask", {
  id: "mask0_2345_69876",
  style: {"mask-type":"luminance"},
  maskUnits: "userSpaceOnUse",
  x: "1",
  y: "1",
  width: "12",
  height: "12"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.63659 12.728H6.36386V1.27344H7.63659V12.728ZM2.54568 2.54616H5.09113V3.81889H2.54568V10.1825H5.09113V11.4553H2.54568C1.84249 11.4553 1.27295 10.8855 1.27295 10.1825V3.81889C1.27295 3.11596 1.84249 2.54616 2.54568 2.54616ZM8.90931 11.4553H10.182V10.1825H8.90931V11.4553ZM11.4548 10.1825V11.4553C12.1579 11.4553 12.7275 10.8855 12.7275 10.1825H11.4548ZM11.4548 8.9098H12.7275V7.63707H11.4548V8.9098ZM12.7275 6.36435H11.4548V5.09162H12.7275V6.36435ZM11.4548 2.54616C12.1579 2.54616 12.7275 3.11596 12.7275 3.81889H11.4548V2.54616ZM10.182 3.81889H8.90931V2.54616H10.182V3.81889Z",
    fill: "white"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("g", { mask: "url(#mask0_2345_69876)" }, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render };